import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToolsService } from 'src/app/services/tools/tools.service';

@Component({
  selector: 'app-disabled-order',
  templateUrl: './disabled-order.component.html',
  styleUrls: ['./disabled-order.component.css']
})
export class DisabledOrderComponent implements OnInit {

  point_of_sale: any = this.tools.getStor("point_of_sale");

  constructor(
    private tools: ToolsService
  ) { }

  ngOnInit() { }
}
